namespace('compass.arctic');

compass.require('compass.demographic.CategorySelectWidget');

compass.arctic.InitialPopupDialogWidget = compass.defineWidget(function InitialPopupDialogWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;

	var _setupControls = function() {
	};

	var _render = this.render = function(widgetElem) {
		widgetElem.addClass("initialPopupWidget");

		var infoSection;
		if (_settings.hotelInfo) {
			infoSection = _drawHotelSection();
		} else if (_settings.drawCopySection) {
			infoSection = _drawCopySection();
		}

		var elementsToAppend = [
			_drawCategorySelect(),
			infoSection,
			d.div({ className : 'clear' })
		];

		// For redesign, add a footer section with login hint
		if (compass.isRedesignEnabled()) {
			elementsToAppend.push(_drawInitialPopupFooter());
		}

		widgetElem.append.apply(widgetElem, elementsToAppend.filter(Boolean));

		_setupControls();
	};

	var _drawCategorySelect = function() {
		var categorySelectHolder = d.div({ className : 'categorySelectHolder'});
		var _categorySelectWidget = new compass.demographic.CategorySelectWidget(categorySelectHolder, {
			WUID : 'CategorySelectWidget_' + _WUID, categories: _settings.categories
		});
		
		// Only append login section to category holder if NOT using redesign
		if (!compass.isRedesignEnabled()) {
			categorySelectHolder.append(_drawLoginSection());
		}

		return categorySelectHolder;
	};

	var _drawCopySection = function() {
		return d.div({ className : 'marketingMessage', role : 'complementary', 'aria-role' : 'complementary'},
			d.div({ className : "marketingHeader" }, "Hotel Reservations"),
			d.div({ className : "marketingCopy" }, "Find your perfect hotel stay and enjoy special benefits."),
			d.ul({ className : 'marketingList' },
				d.li("Lowest Rates"),
				d.li("Easy Group Bookings")
			)
		);
	};

	var _drawHotelSection = function() {
		return d.div({ className : 'hotelInfo'},
			d.div({ className : 'hotelPhotoWrapper'},
				d.img({ className : 'hotelPhoto', src : _settings.hotelInfo.images.main.imagePath, alt : _settings.hotelInfo.images.main.altText})),
			d.div({ className : 'hotelOverlay'}, _settings.hotelInfo.name)
		);
	};

	var _drawLoginSection = function () {
		var loginDiv = d.div({
			className: 'loginHint secondaryText'
		}, "Already have a reservation?",
			d.a({
				href: '#'
			}, "Log in &raquo;").activate(function (event) {
					event.preventDefault();
					me.trigger('InitialPopup.RequestLogin');
					return false;
				})
		);
		
		return loginDiv;
	};

	var _drawInitialPopupFooter = function() {
		var footerDiv = d.div({ className: 'initialPopupFooter' });
		
		// Add login section to footer
		footerDiv.append(_drawLoginSection());
		
		// Add privacy policy link separately in footer for redesign
		if (compass.isRedesignEnabled() && _settings.meetingInfo.privacyPolicyLink && _settings.meetingInfo.privacyPolicyLink.length > 0) {
			footerDiv.append(
				d.a({
					className: 'privacyPolicyLink',
					href: _settings.meetingInfo.privacyPolicyLink,
					target: '_blank',
					'aria-label': 'terms of service and privacy policy'
				}, 'View terms of service and privacy policy')
			);
		}
		
		return footerDiv;
	};

	var d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultInitialPopupDialogWidgetWUID',
	widgetName : 'InitialPopupDialogWidget',
	categories : [],
	meetingInfo : {},
	hotelInfo : false
});

